//import React,{ useState } from 'react';
import {InfoSheet, ConsentForm} from '../utils/Constants.js';

/*This function takes in the data for the pdf document and parses it
into a format that can be interpreted by the pdfMake module*/
function MakeConsentPdf(props){
  //props contain: {user, email, timestamp}
let user = props.user
let email = props.email
let timestamp = props.time

let content =[
  {
    text: InfoSheet.title,
    style: 'header'
  }
]
//format info sheet for pdf
let infoQA = InfoSheet.data.map(
  (item)=> ([{text:item.question+"\n",style:"question"},{text:item.answer+"\n",style:"answer"}])
).flat()
//...and add it to the pdf's content
content = content.concat(infoQA)
content = content.concat(
  {
    text: ConsentForm.title,
    style: 'header'
  }
)
//format consent form for pdf
let consent = ConsentForm.data.map(
  (item)=>({columns:[
    {width: '*', text: item},
    {width: 5, text:''},
    {svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#00795F" stroke="none" d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"/></svg>',
      width: 15
    },
    {width: 35,
      color:"#00795F", text: "Yes", margin:[5,0,0,0]},
    {svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#666666" stroke="none" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200z"/></svg>',
      width: 15
    },
    {width: 35,	text: "No",color:"#666666",margin:[5,0,0,0]},
  ] ,style: "answer"})
)
//...and add it to the pdf's content
content = content.concat(consent)

//format user details
let userDetails = [
  {
    text:"This form was submitted by:",
    style:"subheader"
  },
  {columns:[
    {width: 150, text: "Participant user name",style:'question'},
    {width: '*', text:user, style:"answer"}
  ]},
  {columns:[
    {width: 150, text: "Participant email address",style:'question'},
    {width: '*', text:email, style:"answer"}
  ]},
  {columns:[
    {width: 150, text: "Date",style:'question'},
    {width: '*', text:timestamp, style:"answer"}
  ]}
]
//...and add them to the pdf's content
content = content.concat(userDetails)
//put it all into a single Object for the pdf and add some styling
let doc = {
  content: content,
  styles: {
  		header: {
  			fontSize: 18,
  			bold: true,
        alignment: "center",
        color:'#004C6C',
        margin:[0,20,0,20]
  		},
      subheader: {
        fontSize: 14,
        bold: true,
        alignment: "left",
        color:'#004C6C',
        margin:[0,10,0,10]
      },
  		question: {
  			fontSize: 12,
  			bold: true,
        color:'#00A9B7'
  		},
  		answer: {
        fontSize: 12,
        margin:[5,0,0,10],
        color:'#333333'
  			//italics: true

  		}
    }
}
return(doc)

}


export default MakeConsentPdf;
